import React from "react";

const dummyPrices = [
  { product: "Industrial Pump", priceUSD: 1200 },
  { product: "Gear Assembly", priceUSD: 500 },
  { product: "Hydraulic Cylinder", priceUSD: 850 },
];

export default function SyntraMfgPricingPage({ onClose }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-700">Pricing & Trade Finance (Dummy Data)</h3>
      <div className="grid md:grid-cols-2 gap-4">
        {dummyPrices.map((p, idx) => (
          <div key={idx} className="border rounded-lg p-4 bg-gray-50">
            <p className="font-semibold">{p.product}</p>
            <p className="text-sm text-gray-500">Price (USD): ${p.priceUSD}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
